import {NavLink} from "react-router-dom"
import icon from "../../src/assets/ridgewood-icon-large.png"

export default function AdminHeader() {    
    return <>
        <div className="header">
            <NavLink to="/admin" className="logo">
                <div className="logo quattrocento-bold">
                    <img src={icon} height="50px"/>
                    <h1>Ridgewood</h1>
                </div>
            </NavLink>
            <div className="header-links">
                <NavLink to="/admin/posts">Events</NavLink>
                <NavLink to="/admin/new-post">New Event</NavLink>
            </div>
            <p className="admin-btn">Admin Console </p>
        </div>
    </>
}